import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

import FaceModule from '../FaceModule'
import TimelineModule from '../TimelineModule'
import ExplanationModule from '../ExplanationModule'
import VideoModule from 'components/VideoModule'
import ImageModule from 'components/ImageModule'
import DepakineModule from 'components/DepakineModule'
import MultiVideosModule from 'components/MultiVideosModule'

const defaultProperties: { [key: string]: string } = {
  module: 'video',
  marginTop: '2em',
  marginBottom: '2em',
  videoURL: 'https://unityvideo.appuser.ch/video/uv447247h.mp4',
  videoQuote: "«Les mamans ont l'impression qu'elles sont fautives.»",
  videoCite: 'Natascha Allenbach',
  videoLegend: 'Natashca Allenbach raconte sa premières audience.',
  text: 'text'
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  console.log(properties, { top: properties?.marginTop, bottom: properties?.marginBottom })

  const modules: { [key: string]: ReactElement } = {
    face: <FaceModule />,
    timeline: <TimelineModule />,
    explanation: <ExplanationModule />,
    video: (
      <VideoModule
        src={properties?.videoURL}
        quote={properties?.videoQuote}
        cite={properties?.videoCite}
        legend={properties?.videoLegend}
      />
    ),
    depakine: <DepakineModule />,
    multiVideo: <MultiVideosModule />,
    image: (
      <ImageModule
        src={properties?.imageURL}
        alt={properties?.imageAlt}
        legend={properties?.imageLegend}
        credits={properties?.imageCredits}
      />
    ),
    text: <TextWidth><Text>{properties.text}</Text></TextWidth>
  }

  return (
    <AppContainer
      margins={{ top: properties?.marginTop, bottom: properties?.marginBottom }}
      className={globalClasses.join(' ')}
    >
      {properties?.module && modules[properties.module]}
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)<{ margins: { top: string; bottom: string } }>`
  font-family: var(--font-serif);
  -webkit-font-smoothing: antialiased;
  font-size: 1.8rem;
  line-height: 3rem;
  margin: ${({ margins }) => margins.top || '2em'} 0
    ${({ margins }) => margins.bottom || '2em'} 0;

    // height: 300vh;
    // padding-top: 100vh;
`

const Text = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #7d7d7d;
  font-style: italic;
`

export default MainComponent
